import { Button } from "@/components/ui/Button"
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/Card"

// One section of a settings page: a card that is its own form with its own
// Save, so saving one section never touches another. `id` is the
// table-of-contents anchor; scroll-mt-5 lands it below the pane padding.
export default function SettingsSection({ id, title, description, action, canSave, processing, onSave, children }: {
  id: string
  title: string
  description?: string
  action?: React.ReactNode
  canSave: boolean
  processing: boolean
  onSave: () => void
  children: React.ReactNode
}) {
  return (
    <Card id={id} className="scroll-mt-5">
      <form
        onSubmit={(e) => {
          e.preventDefault()
          onSave()
        }}
      >
        <CardHeader className="flex-row items-start justify-between gap-4 space-y-0">
          <div className="flex flex-col gap-1">
            <CardTitle className="text-base">{title}</CardTitle>
            {description && <CardDescription>{description}</CardDescription>}
          </div>
          {action}
        </CardHeader>
        <CardContent>{children}</CardContent>
        {canSave && (
          <CardFooter className="justify-end">
            <Button type="submit" disabled={processing}>
              {processing ? "Saving…" : "Save"}
            </Button>
          </CardFooter>
        )}
      </form>
    </Card>
  )
}
